// Mock data for CrewFace - AI Headshot Generator for Blue-Collar Teams

export const SAMPLE_HEADSHOTS = [
  { id: 1, name: 'Marcus J.', role: 'Site Foreman', img: 'https://images.unsplash.com/photo-1672748341520-6a839e6c05bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjB3b3JrZXIlMjBoZWFkc2hvdHxlbnwwfHx8fDE3ODQyNjY0NjF8MA&ixlib=rb-4.1.0&q=85&w=600' },
  { id: 2, name: 'David R.', role: 'Journeyman Electrician', img: 'https://images.unsplash.com/photo-1646227655685-a530813759b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHx3b3JrZXIlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODY1NjA1Mzh8MA&ixlib=rb-4.1.0&q=85&w=600' },
  { id: 3, name: 'Anthony K.', role: 'HVAC Tech', img: 'https://images.unsplash.com/photo-1646227655718-dd721b681d91?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHx3b3JrZXIlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODY1NjA1Mzh8MA&ixlib=rb-4.1.0&q=85&w=600' },
  { id: 4, name: 'Jamal S.', role: 'Crew Lead', img: 'https://images.unsplash.com/photo-1679679811837-c28b2586f533?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHx3b3JrZXIlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODY1NjA1Mzh8MA&ixlib=rb-4.1.0&q=85&w=600' },
  { id: 5, name: 'Sara M.', role: 'Safety Officer', img: 'https://images.unsplash.com/photo-1773844389459-110d2b5e18e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxibHVlJTIwY29sbGFyJTIwd29ya2VyJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc4Mzk2NzE3MXww&ixlib=rb-4.1.0&q=85&w=600' },
  { id: 6, name: 'Rick B.', role: 'Warehouse Supervisor', img: 'https://images.pexels.com/photos/4483865/pexels-photo-4483865.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=600' },
  { id: 7, name: 'Eli W.', role: 'Welder', img: 'https://images.pexels.com/photos/12576220/pexels-photo-12576220.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=600' },
  { id: 8, name: 'Lena P.', role: 'Millwright Apprentice', img: 'https://images.pexels.com/photos/9241709/pexels-photo-9241709.jpeg?w=600' }
];

export const TESTIMONIALS = [
  { id: 1, name: 'Priya Nair', role: 'HR Ops, MetroBuild Group', quote: 'We onboarded 320 field workers across 14 sites in one week. ID badges printed on Friday. Zero photo studios needed.', rating: 5 },
  { id: 2, name: 'Wes Turner', role: 'People Ops, GridPoint Electric', quote: 'The badge photos used to take 6 weeks and $18/head. CrewFace did it in 48 hours for less than half the cost.', rating: 5 },
  { id: 3, name: 'Diana Osei', role: 'Regional Director, HaulNorth Logistics', quote: 'Our drivers stopped skipping headshots. They just snap a selfie in the cab and we get clean, uniform photos back.', rating: 5 }
];

export const STATS = [
  { label: 'Headshots generated', value: '184,000+' },
  { label: 'Field teams onboarded', value: '2,400+' },
  { label: 'Avg. cost saved / worker', value: '$14.20' },
  { label: 'Turnaround', value: '< 60s' }
];

export const PRICING = [
  {
    name: 'Crew',
    price: 49,
    unit: '/mo',
    tagline: 'For small crews & subcontractors',
    features: ['Up to 25 seats', '150 headshots / month', 'Mobile self-serve capture', 'Standard backgrounds', 'CSV export'],
    cta: 'Start free trial'
  },
  {
    name: 'Contractor',
    price: 99,
    unit: '/mo',
    tagline: 'For growing subcontractor teams',
    features: ['Up to 75 seats', '300 headshots / month', 'Mobile self-serve capture', 'Standard + premium backgrounds', 'CSV export + batch labeled downloads'],
    cta: 'Start free trial'
  },
  {
    name: 'Site',
    price: 199,
    unit: '/mo',
    tagline: 'For growing field teams',
    features: ['Up to 150 seats', 'High-volume headshots (up to 1,200/mo)', 'Everything in Contractor', 'Badge / ID compliance formatting', 'Priority processing'],
    cta: 'Start free trial',
    highlighted: true
  },
  {
    name: 'Fleet',
    price: null,
    unit: '',
    tagline: 'For large contractors & fleet operators',
    features: ['150+ seats', 'Custom volume, multi-site rollout', 'Dedicated onboarding', 'HR / fleet system integration', 'SOC 2 & GDPR DPA', 'On-prem export'],
    cta: 'Talk to sales'
  }
];

export const FAQ = [
  { q: 'Do workers need to install an app?', a: 'No. They receive a text link, open the mobile web capture, snap a selfie, and get their headshot back. No app store required.' },
  { q: 'What if the lighting on site is bad?', a: 'CrewFace normalizes lighting, removes background, and matches your brand pack automatically. Even a phone selfie in a jobsite trailer produces a clean, uniform result.' },
  { q: 'Can we use these for ID badges?', a: 'Yes. Export in ID-badge-ready formats (2x2, 35x45mm, custom). Print-ready PDFs available on the Site plan and above.' },
  { q: 'Is worker data secure?', a: 'All uploads are encrypted in transit and at rest. Selfies can be auto-deleted after generation. SOC 2 Type II and GDPR-ready contracts on Fleet.' },
  { q: 'Do you work with unions or DOT-regulated fleets?', a: 'Yes. We serve IBEW, Teamsters, and multiple DOT-regulated logistics operators. Custom retention and audit logs available.' }
];

export const COMPETITORS = [
  {
    slug: 'headshotpro',
    name: 'HeadshotPro',
    tagline: 'Consumer AI headshots for office professionals',
    logoInitial: 'HP',
    positioning: 'B2C, corporate & LinkedIn headshots',
    verdict: 'HeadshotPro is the go-to for individual office workers who want a LinkedIn portrait. CrewFace is built for the opposite: batch onboarding of field crews, admin dashboards, and ID-badge output.',
    features: {
      'Batch team onboarding': { us: true, them: false },
      'Admin dashboard': { us: true, them: false },
      'ID badge export (2x2, 35x45mm)': { us: true, them: false },
      'Mobile self-serve capture link': { us: true, them: 'Limited' },
      'HRIS sync (BambooHR, Rippling)': { us: true, them: false },
      'Consumer / individual headshots': { us: 'Not focus', them: true },
      'Studio styles & outfits': { us: 'Uniform-first', them: '150+ styles' },
      'Per-seat B2B pricing': { us: '$49–$199/mo (+ custom Fleet)', them: '$29 one-time' },
      'Turnaround': { us: '< 60 seconds', them: '~2 hours' },
      'SOC 2 / SSO': { us: true, them: false }
    }
  },
  {
    slug: 'aragon-ai',
    name: 'Aragon AI',
    tagline: 'Premium AI headshots for professionals',
    logoInitial: 'A',
    positioning: 'B2C premium, 40+ shots per session',
    verdict: 'Aragon produces gorgeous consumer portraits at a premium price. If you are onboarding 200 field workers, you don\'t need 40 artistic variations per person — you need one clean, on-brand headshot per worker, fast. That\'s CrewFace.',
    features: {
      'Batch team onboarding': { us: true, them: false },
      'Admin dashboard': { us: true, them: false },
      'Uniform / hi-vis preservation': { us: true, them: false },
      'Mobile capture link (no signup)': { us: true, them: false },
      'ID badge print export': { us: true, them: false },
      'HRIS + SCIM': { us: true, them: false },
      '40+ artistic styles per user': { us: false, them: true },
      'Individual pricing': { us: 'Per-seat', them: '$29–$79 one-time' },
      'Turnaround': { us: '< 60 seconds', them: '30–90 min' },
      'Brand consistency across teams': { us: true, them: false }
    }
  },
  {
    slug: 'photoai',
    name: 'PhotoAI',
    tagline: 'General-purpose AI photo generator',
    logoInitial: 'P',
    positioning: 'B2C, creator-oriented photo studio',
    verdict: 'PhotoAI is a powerful creative tool for individuals. It is not built for HR teams onboarding hourly workers, and it does not export ID badges or sync to your HRIS. CrewFace is purpose-built for that job.',
    features: {
      'Batch team onboarding': { us: true, them: false },
      'Role-based admin roles': { us: true, them: false },
      'Hi-vis / hard hat awareness': { us: true, them: false },
      'Mobile capture without account': { us: true, them: false },
      'HRIS sync': { us: true, them: false },
      'Freeform creative prompts': { us: 'Limited', them: true },
      'Per-seat B2B pricing': { us: true, them: false },
      'Turnaround': { us: '< 60 seconds', them: '10–20 min' },
      'Team gallery & approvals': { us: true, them: false },
      'ID badge PDF export': { us: true, them: false }
    }
  },
  {
    slug: 'betterpic',
    name: 'BetterPic',
    tagline: 'Consumer AI headshots, studio-quality',
    logoInitial: 'B',
    positioning: 'B2C, dating & LinkedIn portraits',
    verdict: 'BetterPic delivers polished individual portraits. CrewFace, by contrast, treats headshots as an HR workflow — with team invites, admin approval, and print-ready badges. Different job, different tool.',
    features: {
      'Team-scale onboarding': { us: true, them: false },
      'Admin dashboard & approvals': { us: true, them: false },
      'Uniform preservation': { us: true, them: false },
      'Mobile self-serve link': { us: true, them: false },
      'HRIS integrations': { us: true, them: false },
      'Studio-quality individual portraits': { us: 'Yes, uniform', them: true },
      'Turnaround': { us: '< 60 seconds', them: '~1 hour' },
      'SOC 2': { us: true, them: false },
      'Per-seat pricing': { us: true, them: false },
      'ID badge output': { us: true, them: false }
    }
  },
  {
    slug: 'secta-labs',
    name: 'Secta Labs',
    tagline: 'Premium AI photoshoot for founders & execs',
    logoInitial: 'S',
    positioning: 'B2C premium, executive portraits',
    verdict: 'Secta shines for a founder\'s headshot session. For a field team of 300 electricians onboarding this week, it isn\'t the right shape of product. CrewFace is.',
    features: {
      'Batch team onboarding': { us: true, them: false },
      'Admin dashboard': { us: true, them: false },
      'Uniform / PPE preservation': { us: true, them: false },
      'Mobile capture link': { us: true, them: false },
      'HRIS sync': { us: true, them: false },
      'Premium artistic portraits': { us: 'Uniform-first', them: true },
      'Per-seat B2B pricing': { us: true, them: '$50–$100/user one-time' },
      'Turnaround': { us: '< 60 seconds', them: '24 hours' },
      'ID badge export': { us: true, them: false },
      'SSO / SCIM': { us: true, them: false }
    }
  },
  {
    slug: 'try-it-on-ai',
    name: 'Try It On AI',
    tagline: 'AI virtual try-on & consumer headshots',
    logoInitial: 'T',
    positioning: 'B2C, outfit & style exploration',
    verdict: 'Try It On AI is fun for exploring outfits. If your job is turning 500 selfies into 500 uniform, print-ready badge photos this quarter, CrewFace is the tool.',
    features: {
      'Batch team onboarding': { us: true, them: false },
      'Admin dashboard': { us: true, them: false },
      'Hi-vis / uniform preservation': { us: true, them: false },
      'ID badge export': { us: true, them: false },
      'HRIS integrations': { us: true, them: false },
      'Outfit swap / try-on': { us: false, them: true },
      'Per-seat B2B pricing': { us: true, them: false },
      'Turnaround': { us: '< 60 seconds', them: '5–15 min' },
      'SOC 2 / SSO': { us: true, them: false },
      'Team approval workflow': { us: true, them: false }
    }
  },
  {
    slug: 'ideawave',
    name: 'IdeaWave',
    tagline: 'Validated startup ideas, scored daily',
    logoInitial: 'I',
    positioning: 'Idea discovery platform, not a headshot tool',
    verdict: 'IdeaWave is where this product was first validated as an idea (scored 82/100). CrewFace is the actual built product: the working AI headshot generator, admin dashboard, and HRIS-ready pipeline that turns the IdeaWave concept into a shipping tool your HR team can use today.',
    features: {
      'Working headshot generation': { us: true, them: false },
      'Admin dashboard for field teams': { us: true, them: false },
      'Mobile capture link': { us: true, them: false },
      'HRIS + SSO': { us: true, them: false },
      'ID badge exports': { us: true, them: false },
      'Daily validated idea feed': { us: false, them: true },
      'Founder-fit scoring': { us: false, them: true },
      'Community leaderboard': { us: false, them: true },
      'Trend & market data': { us: false, them: true },
      'Focus': { us: 'Ship & operate', them: 'Discover & validate' }
    }
  }
];

export const FAQ_COMPARE = (them) => [
  { q: `Is CrewFace a good ${them} alternative?`, a: `Yes — if your job is onboarding field crews with uniform, ID-badge-ready photos at scale, CrewFace is purpose-built for that use case, while ${them} is optimized for individual, consumer-style portraits.` },
  { q: `${them} vs CrewFace, which is better?`, a: `It depends on the job. For a single professional wanting a LinkedIn portrait, ${them} is a fine choice. For an HR or People Ops team standardizing headshots across a distributed field workforce, CrewFace wins on batch onboarding, admin controls, HRIS sync, and print-ready badge exports.` },
  { q: `Does CrewFace support batch uploads like ${them}?`, a: `CrewFace was built batch-first. Send a single link to your crew; every worker snaps a selfie on their phone; admins approve in one dashboard.` },
  { q: `How much does CrewFace cost vs ${them}?`, a: `CrewFace uses per-seat B2B pricing across 4 tiers: Crew ($49/mo, up to 25 seats), Contractor ($99/mo, up to 75 seats), Site ($199/mo, up to 150 seats, most popular), and Fleet (custom pricing, 150+ seats with dedicated onboarding). Fleet plans include SSO, SCIM, and SOC 2 documentation.` }
];
